<template>
  <div class="bg-white">
    <div class="w-4/5 mx-auto pt-base pb-base">
      <h5 class="text-center mb-base">
        VideoWiki Private Limited- Terms of Use
      </h5>
      <h5>Terms of Use: User</h5>
      <br />
      <h5 class="mb-4">General</h5>
      <p>
        The domain names i.e.www.videowiki.pt, as available on web are owned by
        VideoWiki Private Limited and its registered office at PCI · Creative
        Science Park, Aveiro Region, 3830-352 Ílhavo, Portugal (here in after
        referred to as "VideoWiki").
      </p>
      <br />
      <p>
        Any User who browses or uses the Site shall be governed by the following
        terms and conditions ("Terms of Use") as applicable to the Site
        including the applicable policies which are incorporated herein by way
        of reference. For the purpose of these Terms of Use, wherever the
        context so requires "You" or "Your" shall mean User. The term "We",
        "Us", "Our" shall mean VideoWiki.
      </p>
      <br />
      <p>
        If You transact on the Site, You shall be subject to the policies that
        are applicable to the Site for such transaction.
        <b
          >By mere use of the Site, You shall be contracting with VideoWiki and
          these terms and conditions including the policies constitute your
          binding obligations, with VideoWiki. If You disagree with these Terms
          of Use, You must not use this Site</b
        >
      </p>
      <br />
      <p>
        (VideoWiki reserves the right to update and/or modify the Terms of Use;
        therefore, User is encouraged to check for changes made to the Terms of
        Use that may affect them. If VideoWiki changes the terms, it shall be
        updated on the Site and shall be considered effective with immediate
        effect. Additionally, VideoWiki reserves the right to refuse services
        under the Terms of Use. User is deemed to agree with and comply with the
        terms and conditions set forth below by VideoWiki.)
      </p>
      <br />
      <h5 class="mb-4">TERMS OF USE</h5>
      <p>
        By using Site, You agree to be bound by the following terms and
        conditions:<br />
        <b>Terms and conditions are contractually binding</b><br />
        these terms and conditions are contractually binding and constitute the
        complete terms and conditions which govern Your use of the Site and the
        Service.
      </p>
      <table>
        <tr>
          <td>
            <h5>Definitions and Interpretation</h5>
            <ol>
              <li>
                In the Terms of Use, unless the context otherwise requires:
                <ol>
                  <li>
                    <b>Agreement</b> means these Terms of Use including any
                    reference of other terms and conditions and/or policy
                    therein.
                  </li>
                  <li>
                    <b>Service</b> means usage of VideoWiki web portal by the
                    User and any other related services provided by VideoWiki.
                  </li>
                  <li>
                    <b>Site</b> means the website www.VideoWiki.com,
                    www.VideoWiki.in that shall be used by the User to avail the
                    Services as stated herein and the User may have the access
                    to avail the Services.
                  </li>
                  <li>
                    <b>Privacy</b> Policy means VideoWiki’s privacy policy which
                    is available on the Site.
                  </li>
                </ol>
              </li>
              <li>
                The paragraph headings in the Terms of Use, incorporated in bold
                and capitalized case, are included to help make provisions of
                Terms of Use easier to read and have no binding effect.
              </li>
              <li>
                Any reference to a clause hereunder is a reference to a clause
                of Terms of Use: User.
              </li>
            </ol>
          </td>
          <td>
            <h5>Legally Binding Agreement</h5>
            <p>
              By accessing or using the Site, You acknowledge that You have
              read, accepted and agreed to be legally bound by these Terms of
              Use and any notices, protocols or guidelines appearing on or in
              connection with the Site, as amended from time to time. Any such
              notices, protocols or guidelines are hereby incorporated by
              reference as part of these Terms of Use.
            </p>
            <br />
            <p>
              You acknowledge and agree that Your access to, and use of, this
              Site is on an 'as available' basis. VideoWiki does not warrant, in
              effect, its availability and is in no way liable for Your failure
              to access and otherwise use this Site.
            </p>
            <p>
              These Terms explain our obligations to You, and Your obligations
              to us, in any transactions You make via this Site.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <h5>Services, Cookies and VideoWiki’s Role</h5>
            <ol>
              <li>
                Services: VideoWiki, through the VideoWiki web portal, provides
                the services to the User pertaining to the personality
                questionnaires and surveys on the Site. VideoWiki facilitates a
                User to register itself on the Site and connects it with the
                VideoWiki to avail the Services when the User posts its intent
                to avail the Services on the Site.
              </li>
              <li>
                Cookies: This Site uses cookies. By using this Site and agreeing
                to these terms and conditions, You consent to VideoWiki's use of
                cookies in accordance with the terms of VideoWiki's cookies
                policy, prescribed under Privacy Policy.
              </li>
              <li>
                VideoWiki’s role: User acknowledges and agrees that for the
                purpose of this Terms of Use, VideoWiki role is of a service
                provider for providing the Services procured by the User
              </li>
            </ol>
          </td>
          <td>
            <h5>Registration:</h5>
            <ol>
              <li>
                The User shall be required to provide necessary data,
                information and proof of documents to register itself on the
                Site (“Registration”). Upon successful Registration to the
                satisfaction of VideoWiki, the User will be issued by VideoWiki,
                upon the suggestion by the User, a username and password to use
                and access the Site. The User agrees that VideoWiki shall be
                entitled to assume that any person using the Site with the
                User's identification number (“User Account”) and/or password is
                the User or its authorized representative.
              </li>
              <li>
                In order to Register and open an "User Account" with VideoWiki,
                You must
                <ol>
                  <li>agree to these Terms of Use,</li>
                  <li>provide a valid email address, and</li>
                  <li>
                    Provide any other information required by VideoWiki during
                    the Registration process.
                  </li>
                  <li>
                    You must update this information to maintain its accuracy
                    during the term of Your Registration for accessing the Site.
                    You are responsible for maintaining the security and
                    confidentiality of Your User Account and password. VideoWiki
                    cannot and will not be liable for any loss or damage from
                    Your failure to comply with this security obligation. You
                    are also responsible for all content that You may post on
                    the Site ("Content") and activity that occurs under Your
                    User Account (even when Content is posted by others by
                    accessing Your account or who have accounts under Your
                    Account), any and all personally identifiable information
                    submitted by You shall be subject to VideoWiki's Privacy
                    Policy, updated from time to time on the Site.
                  </li>
                  <li>
                    One User shall not maintain more than one User Account
                    without the prior written consent of VideoWiki. User Account
                    registered by "bots" or other automated methods are not
                    permitted.
                  </li>
                  <li>
                    The entire process of Registration including creation of
                    User Account and generation of password may take up to seven
                    (7) working days to be processed and approved.
                  </li>
                </ol>
              </li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <h5>Relationship with VideoWiki and User</h5>
            <ol>
              <li>
                The User acknowledges and agrees that details of Services and
                the terms and conditions including warranties, indemnities and
                guarantees of any agreement relating to the Services are to be
                determined solely in accordance of terms and conditions of the
                agreement pertaining to the Services entered between VideoWiki
                and the User.
              </li>
              <li>
                The User acknowledges and agrees that VideoWiki: (i) is a
                service provider for the purpose of providing Services that may
                be availed by the User; and (ii) shall only be liable in any
                manner for any direct loss or damage solely attributable to
                VideoWiki
              </li>
            </ol>
          </td>
          <td>
            <h5></h5>
            <ol>
              <li>
                By accessing or using the Site, You acknowledge that You have
                read, accepted and agreed to be legally bound by these Terms of
                Use and any notices, protocols or guidelines appearing on or in
                connection with the Site, as amended from time to time. Any such
                notices, protocols or guidelines are hereby incorporated by
                reference as part of these Terms of Use.
                <ol>
                  <li>
                    The amount that is agreed by the User at the time of
                    subscription of premium account on the Site (“Fee”);
                  </li>
                  <li>
                    The Fee and/or any other charges are exclusive of all
                    governmental sales, services tax, as well as charges or fees
                    enacted in the future and the User shall be liable to pay
                    applicable tax or statutory levies on the amount of Fee at
                    the prevailing statutory rate.
                  </li>
                </ol>
              </li>
              <li>
                For any and all User Accounts, VideoWiki may charge an account
                re-activation fee should an account need to be re-activated
                after the Use Account has become de-activated due to non-payment
                or for other breaches of the Terms of Use.
              </li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <h5>No Warranties</h5>
            <p>
              You acknowledge and agree that Your use of this Site is as 'made
              available' basis only and may only be available during planned and
              unplanned outages. VideoWiki makes no representation and gives no
              warranty that the alternate login services provided via the Site
              will meet Your requirements, be uninterrupted, timely or
              error-free.
            </p>
          </td>
          <td>
            <h5>User Warranties</h5>
            <p>The User warrants to and agrees with VideoWiki that</p>
            <ol>
              <li>
                It or any authorized person of User is at least eighteen (18)
                years of age or above or is a corporate legal entity duly
                incorporated under the Laws of India. By using this Site and by
                agreeing to Terms of Use, it represent and warrant that it is
                under no legal or other impediment that may prevent it fully
                carrying out and performing its obligations under these Terms of
                Use;
              </li>
              <li>
                all information (including but not limited to that set out in
                the application for Registration (registration form) including
                information relating to User’s is true and correct in every
                respect and will be updated by the User if and when it
                materially changes till the period User’s Registration is active
                with the Site
              </li>
              <li>
                all information provided by the User to VideoWiki will not
                infringe intellectual property rights of any third party and
                will not be false, inaccurate or misleading, abusive, vulgar,
                hateful, harassing, obscene, threatening, defamatory or violate
                any applicable law or regulation
              </li>
              <li>
                it will not impersonate or misrepresent any endorsement by or
                affiliation with any person or entity
              </li>
              <li>
                it will at all-time comply with VideoWiki 's Privacy Policy, as
                prescribed on and updated from time to time on the Site;
              </li>
              <li>
                it will not engage in misleading or deceptive marketing
                practices over the Site;
              </li>
              <li>
                it will not release to the public any news release, advertising
                material, promotional material or any other form of publicity or
                information on the Site without VideoWiki 's prior written
                approval
              </li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <h5>License to use Site</h5>
            <ol>
              <li>
                VideoWiki and/or its licensors own any and all intellectual
                property rights in the Site including any and all materials,
                information and contents on the Site. Subject to the license
                below, all these intellectual property rights are reserved and
                exclusive property of VideoWiki and/or its licensors
              </li>
              <li>
                You may view and download required information or contents from
                the Site as required for the purposes of performing Your
                obligation under these Terms of Use and You may print pages or
                other content from the Site in order to performing Your
                obligation under these Terms of Use, subject to the restrictions
                set out below in sub-clause 3 and elsewhere in these Terms of
                Use:
              </li>
              <li>
                You must not:
                <ol>
                  <li>
                    republish any unauthorized material from this Site
                    (including republication on another website);
                  </li>
                  <li>sell, rent or sub-license material from the Site;</li>
                  <li>
                    show any unauthorized material from the Site in public;
                  </li>
                  <li>
                    reproduce, duplicate, copy or otherwise exploit material on
                    this Site for a commercial purpose;
                  </li>
                  <li>
                    edit or otherwise modify any material on the Site which You
                    are otherwise not authorized to do so, or;
                  </li>
                  <li>
                    Redistribute material from this Site except for content
                    specifically and expressly made available for redistribution
                  </li>
                </ol>
              </li>
            </ol>
          </td>
          <td>
            <h5>Acceptable Use of the Site</h5>
            <ol>
              <li>
                You must not use this Site in any way that causes, or may cause,
                damage to the Site or impairment of the availability or
                accessibility of the Site; or in any way which is unlawful,
                illegal, fraudulent or harmful, or in connection with any
                unlawful, illegal, fraudulent or harmful purpose or activity
              </li>
              <li>
                You must not use this Site to copy, store, host, transmit, send,
                use, publish or distribute any material which consists of (or is
                linked to) any spyware, computer virus, Trojan horse, worm,
                keystroke logger, rootkit or other malicious computer software.
              </li>
              <li>
                You must not conduct any systematic or automated data collection
                activities (including without limitation scraping, data mining,
                data extraction and data harvesting) on or in relation to this
                Site without VideoWiki’s express written consent
              </li>
              <li>
                You must not use this Site to transmit or send unsolicited
                commercial communications.
              </li>
              <li>
                You must not use this Site for any purposes related to marketing
                without VideoWiki’s express written consent.
              </li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <h5>User Content</h5>
            <ol>
              <li>
                In reference to these Terms of Use, “User Content” means
                material (including without limitation text, images, audio
                material, video material and audio-visual material) that You
                submit to this Site, for whatsoever purpose
              </li>
              <li>
                The User Content must not be illegal or unlawful, must not
                infringe any third party's legal rights, and must not be capable
                of giving rise to legal action whether against You or VideoWiki
                or a third party (in each case under any applicable law).
              </li>
              <li>
                VideoWiki reserves the right to edit or remove any material
                submitted to this Site, or stored on VideoWiki’s servers, or
                hosted or published upon this Site.
              </li>
            </ol>
            <br />
            <p>
              Notwithstanding VideoWiki’s rights under these terms and
              conditions in relation to the User Content, VideoWiki does not
              undertake to monitor the submission of such Content to, or the
              publication of such Content on, this Site.
            </p>
          </td>
          <td>
            <h5>Limitations of Liability</h5>
            <ol>
              <li>
                Notwithstanding anything to the contrary under Terms of Use,
                VideoWiki will not be liable to You (whether under the law of
                contact, the law of torts or otherwise including, without
                limitation, negligence, breach of any statute or any other legal
                or equitable obligation) for any claim connected with or arising
                out of use of the Site, provision of the Services and/or and any
                transaction contemplated under the ambit of Terms of Use in
                connection with, the Site:
                <ol>
                  <li>
                    to the extent that the Site is provided free-of- charge, for
                    any direct loss;
                  </li>
                  <li>any indirect, special or consequential loss; or</li>
                  <li>
                    any business losses, loss of revenue, income, profits or
                    anticipated savings, loss of contracts or business
                    relationships, loss of reputation or goodwill, or loss or
                    corruption of information or data.
                  </li>
                </ol>
              </li>
              <li>
                These limitations of liability shall apply even if VideoWiki has
                been expressly advised of the potential loss
              </li>
              <li>
                Subject to Clause 1 and 2 hereinabove, under no circumstances,
                VideoWiki’s liability shall exceed the amount paid by the User
                to VideoWiki in relation to a particular transaction relating to
                procurement of Services.
              </li>
              <li>
                Reasonableness
                <ol>
                  <li>
                    By using this Site, You agree that the exclusions and
                    limitations of liability set out in this Site disclaimer are
                    reasonable
                  </li>
                  <li>
                    If You do not think they are reasonable, You must not use
                    this Site.
                  </li>
                  <li>
                    You accept that, as a limited liability entity, VideoWiki
                    has an interest in limiting the personal liability of its
                    officers and employees. You agree that You will not bring
                    any claim personally against VideoWiki’s officers or
                    employees in respect of any losses You suffer arising in
                    connection with the usage of this Site
                  </li>
                </ol>
              </li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <h5>Unenforceable Provisions</h5>
            <p>
              If any provision of this Site disclaimer is, or is found to be,
              unenforceable under applicable law, that will not affect the
              enforceability of the other provisions of this Site disclaimer.
            </p>
          </td>
          <td>
            <h5>Refunds</h5>
            <p>
              By accessing the Site, and by entering into a transaction in the
              Site, You agree to be bound by the legal terms and conditions
              governing the provision of Services as defined by VideoWiki and
              under the applicable laws. VideoWiki reserves the right to revise
              the legal terms and conditions at any time. All sales are final.
              You may not return, cancel or redeem for cash any of the Services
              after it has been subscribed, unless otherwise stated by VideoWiki
              in agreement entered between VideoWiki and the User pertaining to
              the subscription of Services
            </p>
            <br />
            <p>
              VideoWiki advises that prior to placing a request for subscription
              of Services on the Site, You must carefully review Your selection.
              You agree that in the event of a fraudulent transaction, a
              “chargeback” shall be subject to proper investigation conducted by
              the User’s issuing bank in accordance with their prevalent
              applicable policy. Any other chargeback / refund claim shall be
              given to the User in accordance with prevailing refund policy of
              VideoWiki as mentioned herein above under this Clause "Refund”. If
              You have a question about a charge, You agree to contact us
              through the email address provided in the Terms of Use section.
              VideoWiki shall make reasonable efforts to resolve all doubts in
              relation to the charge(s) that may get accrued.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <h5>Indemnity</h5>
            <p>
              You hereby agree to indemnify and hold harmless VideoWiki and its
              subsidiaries, affiliates, officers, directors, shareholders,
              employees and agents and undertake to keep VideoWiki and its
              subsidiaries, affiliates, officers, directors, shareholders,
              employees and agents indemnified against any losses, damages,
              costs, liabilities and expenses (including without limitation
              legal expenses and any amounts paid by VideoWiki to a third party
              in settlement of a claim or dispute on the advice of VideoWiki’s
              legal advisers) incurred or suffered by VideoWiki arising out of
              any breach by You of any provision of these terms and conditions,
              or arising out of any claim that You have breached any provision
              of these terms and conditions.
            </p>
          </td>
          <td>
            <h5>Breach of Terms of Use</h5>
            <p>
              Without prejudice to User having other rights under these Terms of
              Use, if You breach any Terms of Use in any way, VideoWiki may take
              such action as VideoWiki deems appropriate to deal with the
              breach, including suspending Your access to the Site, prohibiting
              You from accessing the Site, blocking computers using Your IP
              address from accessing the Site, contacting Your internet service
              provider to request that they block Your access to the Site and/or
              bringing court proceedings against You.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <h5>Variation</h5>
            <p>
              VideoWiki may revise these Terms of Use from time-to- time.
              Revised terms and conditions will be effective and applicable to
              the use of this Site from the date of the publication of the
              revised terms and conditions on this Site. Please check this page
              of the Site regularly to ensure You are familiar with the current
              version.
            </p>
          </td>
          <td>
            <h5>Assignment</h5>
            <p>
              VideoWiki may transfer, assign, license, sub-contract or otherwise
              deal with VideoWiki’s rights and/or obligations under the Terms of
              Use without notifying You or obtaining Your consent. However, You
              will not transfer, assign, license, sub-contract or otherwise deal
              with Your rights and/or obligations under the Terms of Use.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <h5>Severability</h5>
            <p>
              If a provision of the Terms of Use is determined by any court or
              other competent authority to be unlawful and/or unenforceable, the
              other provisions will continue in effect. If any unlawful and/or
              unenforceable provision would be lawful or enforceable if a part
              of it were deleted, that part will be deemed to be deleted, and
              the rest of the provision will continue in effect.
            </p>
          </td>
          <td>
            <h5>Entire Agreement</h5>
            <p>
              The Terms of Use constitute the entire agreement between You and
              VideoWiki in relation to Your use of this Site, and supersede all
              previous agreements in respect of Your use of this Site.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <h5>Law and Jurisdiction</h5>
            <p>
              The Terms of Use will be governed by and construed in accordance
              with the laws of Republic of India, and any disputes relating to
              these terms and conditions will be subject to the exclusive
              jurisdiction of the courts of Gurgaon.
            </p>
          </td>
          <td>
            <h5>Contact Email</h5>
            <p>
              You can contact VideoWiki by email at
              <a href="mailto:support@videowiki.pt">support@videowiki.pt</a>
            </p>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Terms Of Use',
};
</script>
<style scoped>
h5 {
  font-weight: 400;
}
p {
  font-size: 0.8rem;
}
table {
  border-collapse: separate;
  border-spacing: 0 4rem;
}
table td {
  width: 50%;
}
table tr {
  vertical-align: baseline;
  /* margin-bottom: 4rem; */
}
table tr td:nth-child(1) {
  padding-right: 2rem;
}
table tr td:nth-child(2) {
  padding-left: 2rem;
}
table tr td h5 {
  margin-bottom: 1.25rem;
}
li {
  font-size: 0.8rem;
}
table tr td ol {
  list-style-type: decimal;
  margin-left: 1rem;
}
table tr td ol li ol {
  list-style-type: lower-alpha;
}
a {
  text-decoration: underline;
}
</style>
